import React, { useEffect } from 'react';

import { BulkEditIssueView } from '../bulk-work-create-common/BulkEditIssueView';
import { BulkConfigureView } from '../bulk-work-create-configure/BulkConfigureView';
import { useAiBulkFetchIssuesList } from '../../services/useAiBulkFetchIssuesList';
import { BulkCreateFlagsContainer } from '../bulk-work-create-common/BulkCreateFlagsContainer';
import { useBulkCreateLoggingEvents } from '../../utils/useBulkCreateLoggingEvents';
import { useGetIssueTypeFields } from '../../services/useGetIssueTypeFields';
import { useHandleCloseAndAddIssuesToPage } from '../../services/useCloseAndAddIssuesToPage';

import { AiBulkDefaultView } from './AiBulkDefaultView';

export const AiBulkNavigationContainer = ({ onClose }: { onClose: () => void }) => {
	const { logAiInteractionInitiated } = useBulkCreateLoggingEvents();
	useGetIssueTypeFields();

	useEffect(() => {
		logAiInteractionInitiated();
	}, [logAiInteractionInitiated]);

	useAiBulkFetchIssuesList();
	useHandleCloseAndAddIssuesToPage(onClose);

	return (
		<>
			<AiBulkDefaultView onClose={onClose} />
			<BulkConfigureView />
			<BulkEditIssueView />
			<BulkCreateFlagsContainer />
		</>
	);
};
